import React, { FC, useEffect, useState } from 'react';
import {
  faChevronLeft,
  faChevronRight,
  // faCircleInfo,
} from '@fortawesome/pro-light-svg-icons';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAtom, useAtomValue } from 'jotai';
import { Col, Container, Image, Modal, Row, Spinner } from 'react-bootstrap';
import { ShowcaseAreaVitrine } from '../../../../../Interface/Vts';
// import NumberInput from '../../../../Abstracts/NumberInput/NumberInput';
import { getRequest } from '../../../../Helper/ApiClient';
import { activeVitrineProduct, scaVitrineId } from '../../Atoms/vtsAtoms';
//@ts-ignore
import styles from './ShowcaseArea.module.scss?module';
// import Button from '../../../../Abstracts/Button/Button';
import ProductAttributes from '../../../../Abstracts/VtsProductList/ProductAttributes/ProductAttributes';
import { formatCurrencyEur } from '../../../../Helper/formatter';

const ShowcaseArea = () => {
  const {
    data: showcaseAreaVitrineData,
    isLoading,
    isError,
    isSuccess,
  } = getRequest<ShowcaseAreaVitrine[]>(
    '/api/onlineshop/vts-show-case-product-sizes'
  );
  const [showModal, setShowModal] = useState(false);
  const [vitrineData, setVitrineData] = useState<
    ShowcaseAreaVitrine | undefined
  >(undefined);
  const [activeProduct, setActiveProduct] = useAtom(activeVitrineProduct);
  const [activeVitrineId, setActiveVitrineId] = useAtom<number | null>(
    scaVitrineId
  );

  useEffect(() => {
    if (showcaseAreaVitrineData && activeVitrineId) {
      setVitrineData(
        showcaseAreaVitrineData.find(
          (vitrine) => vitrine.vitrineId === activeVitrineId
        )
      );
      setShowModal(true);
    }
  }, [showcaseAreaVitrineData, activeVitrineId]);

  useEffect(() => {
    setActiveProduct(vitrineData?.products[0]);
  }, [vitrineData]);

  const handlePrevClick = () => {
    if (notFirstVitrine && activeVitrineId !== null) {
      setActiveVitrineId(activeVitrineId - 1);
    }
  };

  const handleNextClick = () => {
    if (notLastVitrine && activeVitrineId !== null) {
      setActiveVitrineId(activeVitrineId + 1);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setTimeout(() => {
      setActiveVitrineId(null);
    }, 300);
  };

  function getBrandVideo(erp_id: number) {
    return brandVideos.find((brand) => brand.erp_id === erp_id)?.video_url;
  }

  const notLastVitrine =
    activeVitrineId !== null &&
    showcaseAreaVitrineData &&
    activeVitrineId < showcaseAreaVitrineData?.length;

  const notFirstVitrine =
    activeVitrineId !== null &&
    showcaseAreaVitrineData &&
    showcaseAreaVitrineData?.length > 0 &&
    activeVitrineId > 1;

  return (
    <Modal
      dialogClassName={styles.ModalDialog}
      onHide={handleClose}
      scrollable={false}
      show={showModal}
      centered
      size="xl"
    >
      <Modal.Body className="px-0 px-md-3">
        {isLoading && (
          <div className="text-center">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Laden...</span>
            </Spinner>
          </div>
        )}

        {isError && (
          <div className="text-danger py-4 fs-4 px-4">
            Fehler beim Laden der Daten. Bitte versuchen Sie es später erneut.
          </div>
        )}

        {isSuccess && vitrineData && (
          <>
            <CloseButton
              className={`${styles.CloseButton} d-none d-md-flex`}
              handleClose={handleClose}
            />

            <Container fluid>
              <Row className="justify-content-between">
                <Col md={3}>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-md-column gap-3 gap-md-0">
                      <p className={`${styles.NavigationProgressNums} m-0`}>
                        0{activeVitrineId}/0{showcaseAreaVitrineData?.length}
                      </p>
                      <div
                        className={`${styles.NavigationArrowContainer} d-flex gap-2 pt-lg-2`}
                      >
                        <button
                          className={!notFirstVitrine ? styles.Disabled : ''}
                          disabled={!notFirstVitrine}
                          onClick={handlePrevClick}
                        >
                          <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <button
                          className={!notLastVitrine ? styles.Disabled : ''}
                          disabled={!notLastVitrine}
                          onClick={handleNextClick}
                        >
                          <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                      </div>
                    </div>
                    <div>
                      <CloseButton
                        className="d-md-none"
                        handleClose={handleClose}
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={8} className="position-relative pt-4 pt-lg-0">
                  <VitrineProductsImages
                    key={activeVitrineId}
                    vitrineProducts={vitrineData.products}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} lg={3} className="position-relative">
                  <video
                    className="w-100 h-auto pt-4 pt-lg-0"
                    style={{
                      minHeight: '570px',
                    }}
                    src={getBrandVideo(Number(activeProduct?.erp_id))}
                    autoPlay
                    muted
                    controls
                    loop
                  />
                  {/* <div className={styles.Discount}>
                    {activeProduct?.discount}
                    {'%'}
                  </div> */}
                </Col>
                <Col className={styles.ProductInfoSection} sm={12} lg={4}>
                  <div className="text-center">
                    <Image
                      className="w-75 h-auto pt-4 pt-lg-0"
                      src={activeProduct?.image_url}
                      alt={`${activeProduct?.name}`}
                    />
                  </div>

                  <div className="d-flex flex-column gap-1 m-0">
                    <p className={styles.BrandName} aria-label="brand-name">
                      {activeProduct?.brand_name}
                    </p>
                    <p className={styles.ProductName} aria-label="product-name">
                      {activeProduct?.name}
                    </p>
                    {/* <p>
                      Strickly Bullet {'/'} Bullet {'/'} Bullet <br /> More
                      Bullet {'/'} max{' '}
                    </p> */}
                  </div>

                  <div className="pt-2">
                    {activeProduct?.promotion_text && (
                      <div className={'w-100 px-3 py-2 bg-danger'}>
                        <span
                          className={
                            'd-block text-white fw-bold fst-italic text-center'
                          }
                        >
                          {activeProduct.promotion_text}
                        </span>
                      </div>
                    )}
                  </div>

                  <div className="text-end">
                    <div className="d-flex flex-column align-items-end justify-content-end">
                      <small className="fst-italic text-decoration-line-through">
                        {formatCurrencyEur(activeProduct?.regular_price)}
                      </small>
                      <div className={'type-price text-danger'}>
                        {formatCurrencyEur(activeProduct?.current_price)}
                      </div>
                    </div>
                  </div>

                  {/* price alt*/}
                  {/* <div className="d-flex justify-content-between align-items-center pt-4">
                    <p className={`${styles.Price}`} aria-label="price">
                      {activeProduct?.current_price}€
                    </p>

                    <div className="d-lg-none">
                      <FontAwesomeIcon
                        className="cursor-pointer"
                        size="2x"
                        icon={faCircleInfo}
                      />
                    </div>
                  </div> */}

                  {/** /}
                  <div className="d-lg-none">
                    <ProductFlavour />

                    <div className="text-end pt-4">
                      <Button className="text-uppercase">add to basket</Button>
                    </div>
                  </div>
                  {/**/}

                  {/* <div>
                    <p aria-label="product-description" className="pt-4">
                      {activeProduct?.description}
                    </p>
                  </div> */}

                  {/* <div className="pt-5 d-none d-lg-flex">
                    <FontAwesomeIcon
                      className="cursor-pointer"
                      size="xl"
                      icon={faCircleInfo}
                    />
                  </div> */}
                </Col>
                {/** /}
                <Col className="d-none d-lg-flex flex-column" sm={12} lg={4}>
                  <ProductFlavour />

                  <div className="h-100 w-100 d-flex justify-content-end align-items-end">
                    <Button className="text-uppercase">add to basket</Button>
                  </div>
                </Col>
                {/**/}
                <Col
                  className={`${styles.OrderMaskeContainer} mt-4`}
                  sm={12}
                  lg={5}
                >
                  {activeProduct && (
                    <ProductAttributes
                      positions={[]}
                      setPositions={() => {}}
                      price={activeProduct.current_price}
                      product_attributes={activeProduct.product_attributes}
                    />
                  )}
                </Col>
              </Row>
            </Container>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ShowcaseArea;

type CloseButtonPropT = {
  handleClose: () => void;
  className?: string;
};

const CloseButton: FC<CloseButtonPropT> = ({ handleClose, className }) => {
  return (
    <div className={className} style={{ zIndex: 3 }} onClick={handleClose}>
      <div />
      <FontAwesomeIcon className={styles.CloseIcon} icon={faCircleXmark} />
    </div>
  );
};

type VitrineProductImagesPropsT = {
  vitrineProducts: ShowcaseAreaVitrine['products'];
};

const VitrineProductsImages: FC<VitrineProductImagesPropsT> = ({
  vitrineProducts,
}) => {
  const [activeProduct, setActiveProduct] = useAtom(activeVitrineProduct);

  return (
    <div
      className={`${styles.ProductImageContainer} pe-lg-1 pt-lg-4 pt-xxl-0`}
      style={{ gridTemplateColumns: `repeat(${vitrineProducts.length}, 1fr)` }}
    >
      {activeProduct &&
        vitrineProducts.map((product) => {
          return product.image_url ? (
            <Image
              key={product.id}
              src={product.image_url}
              className={
                activeProduct.id === product.id ? styles.ActiveProduct : ''
              }
              draggable={false}
              alt={`product ${product.name} Image`}
              onClick={() => setActiveProduct(product)}
            />
          ) : null;
        })}
    </div>
  );
};

// const ProductFlavour = () => {
//   const activeProduct = useAtomValue(activeVitrineProduct);

//   return (
//     <div className={`${styles.FlavourContainer} pt-4`}>
//       <table className="w-100 px-2">
//         <tbody>
//           {activeProduct?.product_attributes.map((flavour) => (
//             <tr key={flavour.id}>
//               <td>
//                 <strong>{flavour.name}</strong>
//               </td>
//               <td>
//                 <NumberInput
//                   className={`${styles.TdInput} w-100 h-100`}
//                   // loading={}
//                   // invalid={isInvalid}
//                   inputValue={undefined}
//                   onChange={(value) => {}}
//                   // onBlur={handleInputBlur}
//                 />
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

const BRAND_VIDEOS_URL =
  'https://files.naskorsports.com/shop/virtual-trade-show/brand-videos';
const brandVideos = [
  {
    erp_id: 38401,
    video_url: `${BRAND_VIDEOS_URL}/Applied.mp4`,
  },
  {
    erp_id: 22352,
    video_url: `${BRAND_VIDEOS_URL}/C4.mp4`,
  },
  {
    erp_id: 19219,
    video_url: `${BRAND_VIDEOS_URL}/Dymatize.mp4`,
  },
  {
    erp_id: 10370,
    video_url: `${BRAND_VIDEOS_URL}/Grenade.mp4`,
  },
  {
    erp_id: 37123,
    video_url: `${BRAND_VIDEOS_URL}/Nutrex.mp4`,
  },
  {
    erp_id: 36929,
    video_url: `${BRAND_VIDEOS_URL}/Mars.mp4`,
  },
  {
    erp_id: 22458,
    video_url: `${BRAND_VIDEOS_URL}/Mutant.mp4`,
  },
  {
    erp_id: 24668,
    video_url: `${BRAND_VIDEOS_URL}/Peak.mp4`,
  },
  {
    erp_id: 20330,
    video_url: `${BRAND_VIDEOS_URL}/PHD.mp4`,
  },
  {
    erp_id: 25158,
    video_url: `${BRAND_VIDEOS_URL}/QNT.mp4`,
  },
  {
    erp_id: 31867,
    video_url: `${BRAND_VIDEOS_URL}/Sunwarrior.mp4`,
  },
  {
    erp_id: 40716,
    video_url: `${BRAND_VIDEOS_URL}/Zec+.mp4`,
  },
] as const;
